import React from 'react';
import { useTranslation } from 'react-i18next';

import { NextImage, Typography } from '@/shared/components/atoms';

import BusinessAppQRCodeAndroid from '~/images/Ecosystem/BusinessAppQRCodeAndroid.png';
import BusinessAppQRCodeIOS from '~/images/Ecosystem/BusinessAppQRCodeIOS.png';
import FieldAppQRCode from '~/images/Ecosystem/FieldAppQRCode.png';

const AppQRCodeModal: React.FC<{
  type: 'field' | 'business';
}> = ({ type }) => {
  const { t } = useTranslation('onboarding');
  return (
    <div className='flex flex-col items-center gap-16 text-center'>
      <Typography variant='h6' weight='medium'>
        {t(
          type === 'business' ? 'download-business-app' : 'download-field-app'
        )}
      </Typography>
      <Typography variant='button' className='text-surface-10'>
        {t('open-camera-scan')}
      </Typography>
      <div className='flex items-center gap-24'>
        <NextImage
          alt={
            type === 'field'
              ? 'download-field-app'
              : 'download-business-app-ios'
          }
          width={250}
          height={250}
          src={type === 'field' ? FieldAppQRCode : BusinessAppQRCodeIOS}
        />
        {type === 'business' && (
          <NextImage
            alt='download-business-app-android'
            width={250}
            height={250}
            src={BusinessAppQRCodeAndroid}
          />
        )}
      </div>
    </div>
  );
};

export { AppQRCodeModal };
